import React from 'react';
import { Container, Wrapper } from './Fallback.styles';
import { ReactComponent as AlertIcon } from 'App/assets/img/alert-icon.svg';
import { Button } from '@welbe/design-system';
import { useNavigate } from 'react-router-dom';

export const Fallback = () => {
	const navigate = useNavigate();

	return (
		<Wrapper>
			<Container>
				<div>
					<h2>Contenido no disponible</h2>
					<p>
						Lo sentimos, pero este contenido no está disponible actualmente para
						usted.
					</p>
					<p>
						Si cree que es un error, comuníquese con nuestro soporte por chat o
						correo electrónico.
					</p>
					<Button width="fit-content" onClick={() => navigate('/')}>
						Home
					</Button>
				</div>
				<AlertIcon />
			</Container>
		</Wrapper>
	);
};
